<template>
    <a-modal
      :visible="moveToData ? true : false"
      title="Move Ethnicities"
      @cancel="handleCancel"
      :maskClosable="false"
    >
      <a-row>
        <a-col :xs="24" :lg="24">
          <!-- 国家 -->
          <a-form-item>
            <span slot="label">Move <strong>{{ moveToData ? moveToData.enName : '' }}</strong> after</span>
            <a-select
              v-model="moveToCurrentId"
              style="width: 100%;"
              :showSearch="true"
              optionFilterProp="children"
              v-decorator="[
                'ethnicities',
                { rules: [{ required: true, message: 'Please select ethnicities!' }] },
              ]"
            >
              <a-select-option :value="'top'">Top</a-select-option>
              <a-select-option v-for="i in ethnicitiesList" :key="'ethnicities-' + i.id" :value="i.id">{{ i.enName }}</a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
      </a-row>
      <template slot="footer">
          <a-button type="primary" @click="handleOk" :loading="saving">
            Confirm
          </a-button>
      </template>
    </a-modal>
</template>

<script>
import EthnicitiesApi from '@/api/dict/api-ethnicities'

export default {
  name: 'EthnicitiesMove',
  components: {
  },
   props: {
    initData: {
      type: [Object],
      default: null
    }
  },
  data () {
    return {
      ethnicitiesList: [],
      moveToData: null,
      moveToCurrentId: null,
      saving: false,
    }
  },
  created () {
  },
  mounted () {
    this.loadData()
  },
  methods: {
    async loadData () {
      this.saving = false
      this.moveToCurrentId = 'top'
      this.moveToData = this.initData
      const resEthnicities = await EthnicitiesApi.list()
      const ethnicitiesList = resEthnicities.data
      this.ethnicitiesList = ethnicitiesList

    },
    async handleOk () {
      this.saving = false
      if (this.moveToCurrentId === 'top') {
        await EthnicitiesApi.moveTo(this.moveToData.id)
      } else {
        await EthnicitiesApi.moveTo(this.moveToData.id, this.moveToCurrentId)
      }
      this.saving = true
      this.$emit('ok')
    },
    handleCancel () {
      this.$emit('cancel')
    }
  },
  watch: {
    initData () {
      this.loadData()
    }
  }
}
</script>
